<template>
  <div class="wrap">
    <JNav :title="$t('安全中心')" />
    <div class="cont">
      <div class="cont_top">
        <div class="circle">
          <van-circle :value="currentRate" layer-color="#f5f5f5" :rate="currentRate" :size="80" stroke-width="60"
            :speed="100">
            <div class="circle_text">
              {{ text }}
            </div>
          </van-circle>
        </div>
        <div class="right">
          <div class="right_top">
            <div class="center_header">{{ $t('安全百分比') }}：
              <div>
                {{ currentRate < 50 ? $t('低') : currentRate <= 100 ? $t('中') : $t('高') }} </div>
              </div>
              <div class="center_svgBox">
                <template v-for="index in num">
                  <img src="../../../assets/icon/fast_active.png" alt="" :key="index">
                </template>
                <template v-for="index in (5 - num)">
                  <img src="../../../assets/icon/fast.png" alt="" :key="`_${index}`">
                </template>
              </div>
            </div>
            <div class="flex_tips">{{ $t('上次登录IP') }}:
              <span>{{ userInfo.lastip }}</span>
            </div>
            <div class="flex_tips">
              {{ $t('最后登录时间') }}：
              <span>{{ $format(userInfo.lastdate) }}</span>
            </div>
          </div>
        </div>
        <div class="am_flexbox" v-if="currentRate != 100">{{ $t('您的账户等级过低') }}</div>
        <div class="cont_list">
          <div class="list_" v-for="item, index in list" :key="index" @click="handleTo(item)">
            <template v-if="index == 4 && userInfo.auth_status">
              <div class="status">{{ userInfo.auth_status }}</div>
            </template>
            <div class="list">
              <div class="list_left">
                <div class="img">
                  <img :src="item.icon">
                </div>
                <div class="left_text">
                  <div class="title">
                    <span>{{ $t(item.title) }}</span>
                    <van-icon name="warning" color="#ff2627" size="20" v-if="!item.flag" />
                    <van-icon name="checked" color="#00e354" size="20" v-else />
                  </div>
                  <div class="subtitle">
                    {{ $t(item.subtitle) }}
                  </div>
                </div>
              </div>
              <van-icon name="arrow" color="#A6A6A6" size="20" />
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import JNav from "@/components/JNav"
import { Circle, Toast, Icon } from "vant"
export default {
  components: {
    JNav,
    [Circle.name]: Circle,
    Toast,
    [Icon.name]: Icon
  },
  data() {
    return {
      userInfo: {},
    }
  },
  computed: {
    list() {
      return [{
        icon: require('@/assets/new/mine/profile.png'),
        title: '个人信息',
        subtitle: '完善个人信息',
        url: '/Account',
        flag: this.userInfo.email ? true : false
      }, {
        icon: require('@/assets/new/mine/bindEwallet.png'),
        title: '绑定电子钱包',
        subtitle: '绑定电子钱包进行提现',
        url: '/walletList',
        flag: this.userInfo.existbank > 0 ? true : false
      }, {
        icon: require('@/assets/new/mine/password.png'),
        title: '修改登录密码',
        subtitle: '推荐字母和数字',
        url: '/Password',
        flag: this.userInfo.setpass > 0 ? true : false
      }, {
        icon: require('@/assets/new/mine/pay_password.png'),
        title: '交易密码',
        subtitle: '设置交易密码',
        url: '/PaymentCode',
        flag: this.userInfo.setpaypass > 0 ? true : false
      }, {
        icon: require('@/assets/new/mine/verification.png'),
        title: 'KYC认证',
        subtitle: 'KYC认证',
        url: '/Certification',
        flag: this.userInfo.auth_level > 0 ? true : false
      }]
    },
    currentRate() {
      let arr = this.list && this.list.filter(item => item.flag);
      let len = (arr.length - 0) * 10;
      return len + 50;
    },
    text() {
      return Number(this.currentRate.toFixed(2)) + '%';
    },
    num() {
      if (this.currentRate == 50) return 3;
      if (this.currentRate < 100) return 4;
      if (this.currentRate == 100) return 5;
      return 3
    },
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    handleTo(item) {
      if (!item.url) return;
      this.$router.push(item.url)
    },
    getUserInfo() {
      Toast.loading();
      this.$api.getUserInfo(
        (res) => {
          Toast.clear();
          this.userInfo = { ...res };
        },
        (err) => {
          Toast.clear();
        }
      );
    },
  }
}
</script>
<style lang="less" scoped>
.wrap {
  min-height: 100vh;
  background-image: linear-gradient(#f5f5f5, #f5f5f5), linear-gradient(#ccc, #ccc);

  .cont {
    .cont_top {
      margin: calc(12.5rem / 16);
      min-height: calc(100rem / 16);
      position: relative;
      display: flex;
      align-items: center;
      justify-content: left;
      background: #fff;
      box-shadow: 0 3px 16px 0 rgba(0, 0, 0, .08);
      border-radius: 5px;
      padding: 10px;
      gap: 15px;

      .circle {
        .circle_text {
          width: 80px;
          height: 80px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #A77DFA;
        }
      }

      .right {
        flex: 1;

        .right_top {
          padding-top: calc(12rem / 16);
          display: flex;
          flex-wrap: wrap;
          align-items: center;

          .center_header {
            display: flex;
            align-items: center;
            font-size: calc(15rem / 16);
            color: #48484e;
            margin-bottom: calc(12rem / 16);
            font-weight: bold;
            line-height: 1;
          }

          .center_svgBox {
            display: flex;
            align-items: center;
            gap: calc(6rem / 16);
            margin-left: calc(5rem / 16);
            height: calc(26rem / 16);

            img {
              width: 12px;
              display: block;
            }
          }
        }

        .flex_tips {
          color: #878787;
          font-size: calc(12rem / 16);
          line-height: calc(19rem / 16);
          word-break: break-word;
          white-space: wrap;
          max-width: 100%;
        }
      }
    }

    .am_flexbox {
      padding: calc(11rem / 16) calc(10rem / 16);
      color: #ea3324;
      font-size: calc(15rem / 16);
      text-align: center;
    }

    .cont_list {
      // padding: 0 calc(12rem / 16) calc(25rem / 16);
      box-shadow: 0 3px 16px 0 rgba(0, 0, 0, .08);
      border-radius: 5px;
      background-image: linear-gradient(#f5f5f5, #f5f5f5), linear-gradient(#ccc, #ccc);
      margin: 0 12.5px;
      overflow: hidden;
      .list_{
        border-top: 1px solid #ddd;
        padding: 0 20px;
        background-color: var(--light);
      }
      .list {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .list_left {
          display: flex;
          align-items: center;
          gap: calc(20rem / 16);
          padding: calc(7rem / 16) 0;
          line-height: 1.5;
          flex: 1;

          .img {
            width: calc(40rem / 16);
            height: calc(40rem / 16);
            display: flex;
            align-items: center;
            justify-content: center;

            img {
              height: 100%;
              display: block;
            }
          }

          .left_text {
            flex: 1;
            padding: 0 calc(12rem / 16);

            .title {
              font-size: calc(14rem / 16);
              font-weight: bold;
              color: #5e5e5e;
              padding: calc(2.5rem / 16) 0;
              display: flex;
              align-items: center;

              span {
                margin-right: calc(7rem / 16);
              }
            }

            .subtitle {
              font-size: calc(11rem / 16);
              color: #a6a6a6;
              column-gap: calc(10rem / 16);
              display: flex;
              align-items: center;
              justify-content: space-between;

            }

          }
        }
      }
      .status {
        text-align: right;
        font-size: calc(14rem / 16);
        color: red;
        padding-top: calc(5rem / 16);
      }

      .list:nth-child(1) {
        border-top: none;
      }
    }
  }
}
</style>